import React from "react";
import oneDoorLogo from "../assets/odp.png";

export default function LogoOneDoor({ className = "", imgClassName = "" }) {
  const containerClass = className?.trim() ? className : "h-[64px] w-[64px]";
  const imgClass = imgClassName?.trim() ? imgClassName : "h-[56px] w-auto object-contain";

  return (
    <div className={`bg-white flex items-center justify-center rounded ${containerClass}`}>
      <img
        src={oneDoorLogo}
        alt="One Door"
        className={imgClass}
        draggable={false}
      />
    </div>
  );
}
